import React from 'react';
import { Project } from '../types';
import { ROOM_LABEL, TAG_LABELS } from '../data';

interface Props {
  project: Project;
  isActive: boolean;
  onSelect: (id: number) => void;
}

const ProjectCard: React.FC<Props> = ({ project, isActive, onSelect }) => {
  const roomEntries = (Object.entries(project.rooms) as [string, number][])
    .filter(([, c]) => c > 0)
    .sort(([a], [b]) => Number(a) - Number(b));

  return (
    <article
      className={`sa-card ${isActive ? 'sa-card--active' : ''}`}
      onClick={() => onSelect(project.id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(project.id);
        }
      }}
    >
      <div className="sa-card__inner">
        <div className="sa-card__title">{project.name}</div>

        <div className="sa-card__rooms">
          {roomEntries.map(([rooms, count], idx) => (
            <React.Fragment key={rooms}>
              <div className="sa-card__room">
                <span className="sa-card__room-label">
                  {ROOM_LABEL(Number(rooms) as 0 | 1 | 2 | 3 | 4)}
                </span>
                <span className="sa-card__room-count">{count}</span>
              </div>
              {idx < roomEntries.length - 1 && (
                <span className="sa-card__divider" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="sa-card__tags">
        {project.tags.map((tag) => (
          <span key={tag} className={`sa-card__tag sa-card__tag--${tag}`}>
            {TAG_LABELS[tag]}
          </span>
        ))}
      </div>
    </article>
  );
};

export default ProjectCard;